<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createWorkflowAttribute">
              <div class="col-md-5">
                <h5>Information</h5>
                <br>
                <form-text ref="name" label="Name" name="name" v-model="workflowAttribute.name" validation="required"></form-text>
                <form-select ref="type" label = "Type" name="type" v-model="workflowAttribute.type" :options="inputTypes" validation="required"></form-select>
                <br>
                <form-checkbox label="Active" name="active" v-model="workflowAttribute.active"></form-checkbox>
              </div>
              <br>
              <div class="col-md-5">
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextArea from '../../elements/Form/FormTextArea'
import ActiveFormCheckbox from '../../elements/Form/ActiveFormCheckbox'
import FormSelect from '../../elements/Form/FormSelect'
import database from '../../webmaster/Database/database'
import firebase from 'firebase'
import axios from 'axios'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createworkflowattribute',
  components:{
    'form-text':FormText,
    'form-checkbox':ActiveFormCheckbox,
    'form-textarea':FormTextArea,
    'form-select':FormSelect
  },
  data () {
    return {
      workflowAttribute: {
        name: '',
        active: true,        
        type: 'number'
      },
      inputTypes: [{'name': "Number", '.key': "number"}, {'name': "Text", '.key': "text"}, {'name': "True/False", '.key': "bool"}]
    }
  },
  methods: {
    createWorkflowAttribute:function(e){
      e.preventDefault()
      var self = this
      let promises = [];
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var curOrgId = self.$store.state.usermain.curOrg.id
        var newWorkflowAttributeKey = database.getDb().ref().child('orgs').child(curOrgId).child('workflow_attributes').push().key;
        var updates = {};
        updates['/orgs/' + curOrgId + '/workflow_attributes/' + newWorkflowAttributeKey] = self.workflowAttribute;
        database.getDb().ref().update(updates, function(){
          self.$router.push('/admin/workflowattributes')
        });
      }, () => {});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateWorkflowAttribute.vue?64e8fc06